export const CONTAINER = 'container';
export const STANDARD = 'standard';
export const FULLSCREEN = 'fullscreen';
export const PLAYER_ZONE = 'player';
export const TEXT = 'text';
export const BUTTON = 'button';
export const IMAGE = 'image';
export const PROMO_CLOSE = 'promoCloseButton';
export const CLOSE_BUTTON = 'closeButton';
export const AUTO_CLOSE = 'autoClose';
export const AUTO_CLICK = 'autoClick';


export const POLL_CHART = 'chart';
export const POLL_STATE = 'pollState';
export const POLL_STATE_VOTE = 'vote';
export const POLL_STATE_RESULT = 'result';

export const SCROLL_CONTAINER ='scrollContainer';
